import * as React from 'react';
import moment from 'moment-timezone';
import { useLocation } from 'react-router-dom';
import { ReclayZahlung } from './ReclayZahlung';

export const ReclayZahlungPrint: React.FC = () => {
    const location = useLocation();
    const urlSearchParams = new URLSearchParams(location.search);

    const abrJahrS = urlSearchParams.get('abrJahr');
    const abrJahr = abrJahrS ? parseInt(abrJahrS, 10) : moment().year();

    const abrMoS = urlSearchParams.get('abrMo');
    const abrMo = abrMoS ? parseInt(abrMoS, 10) : moment().year();

    const showDetails = urlSearchParams.get('showDetails') === 'true';

    return <ReclayZahlung abrJahr={abrJahr} abrMo={abrMo} showDetails={showDetails} printView />;
};
